var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('p',[_c('i',[_vm._v(_vm._s(_vm.$t('Table.msg')))])]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger","to":{name: 'Home'}}},[_vm._v(_vm._s(_vm.$t('Table.homeLink')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f89d8b9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table.vue
// module id = null
// module chunks = 